const constants = {
  BASE_URL:
    window.location.hostname === "localhost"
      ? "http://localhost:3010"
      : "https://api.fale.co.nz",
  EVENTS: {
    ORDER_ACCEPTED: "ORDER_ACCEPTED",
  },
};

class Requeste {
  constructor(url, options) {
    this.url = `${constants.BASE_URL}${url}`;
    this.options = options;
  }

  authee() {
    const token = localStorage.getItem("sessionToken");
    this.options = {
      ...this.options,
      headers: {
        ...this.options.headers,
        token,
      },
    };
    return this;
  }

  cachee(key) {
    this.cacheKey = key;

    return this;
  }

  jsonee() {
    this.isJson = true;

    return this;
  }

  async fetch() {
    let stored;
    if (this.cacheKey) {
      const cached = localStorage.getItem(this.cacheKey);
      if (cached) {
        stored = JSON.parse(cached);
        this.url = stored.hash ? `${this.url}?hash=${stored.hash}` : this.url;
      }
    }

    let fn = fetch(this.url, this.options);
    if (this.isJson) {
      fn = fn.then((resp) => resp.json());
    }

    if (this.cacheKey) {
      const { data, hash } = await fn;
      const result = stored?.hash === hash ? stored.data : data;

      localStorage.setItem(
        this.cacheKey,
        JSON.stringify({
          data: result,
          hash,
        })
      );

      return result;
    }

    return fn;
  }
}

export default {
  constants,
  files: {
    upload: async (file, name) => {
      const payload = new FormData();
      payload.append(name, file);
      return new Requeste("/auth/upload", {
        method: "POST",
        body: payload,
      })
        .jsonee()
        .fetch();
    },
  },
  authentication: {
    login: async (email, password) =>
      new Requeste("/auth/login", {
        method: "POST",
        body: JSON.stringify({ usernameOrEmail: email, password }),
        headers: { "Content-Type": "application/json" },
      })
        .jsonee()
        .fetch(),
    signup: async (payload) =>
      new Requeste("/auth/signup", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
      })
        .jsonee()
        .fetch(),
  },
  products: {
    getForKitchen: (kitchenId, statuses) =>
      new Requeste(`/kitchen/${kitchenId}/products?statuses=${statuses}`, {
        method: "GET",
      })
        .authee()
        .jsonee()
        .fetch(),
    save: (kitchenId, product) =>
      new Requeste(`/kitchen/${kitchenId}/product`, {
        method: "POST",
        body: JSON.stringify(product),
        headers: { "Content-Type": "application/json" },
      })
        .authee()
        .jsonee()
        .fetch(),
    goLive: (id) =>
      new Requeste(`/product/${id}/live`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .authee()
        .jsonee()
        .fetch(),
    makeDraft: (id) =>
      new Requeste(`/product/${id}/draft`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .authee()
        .jsonee()
        .fetch(),
  },
  kitchens: {
    getAll: () =>
      new Requeste("/kitchens", {
        method: "GET",
      })
        .cachee("kitchens")
        .authee()
        .jsonee()
        .fetch(),
    updateSettings: (kitchenId, settings) =>
      new Requeste(`/kitchen/${kitchenId}/settings`, {
        method: "POST",
        body: JSON.stringify(settings),
        headers: { "Content-Type": "application/json" },
      })
        .authee()
        .jsonee()
        .fetch(),
  },
  orders: {
    place: (order, preview = false) =>
      new Requeste("/order/place", {
        method: "POST",
        body: JSON.stringify({ ...order, preview }),
        headers: { "Content-Type": "application/json" },
      })
        .authee()
        .jsonee()
        .fetch(),
    getForKitchen: (kitchenId, statuses) =>
      new Requeste(`/kitchen/${kitchenId}/orders?statuses=${statuses}`, {
        method: "GET",
      })
        .authee()
        .jsonee()
        .fetch(),
    getForUser: () =>
      new Requeste("/orders", {
        method: "GET",
      })
        .authee()
        .jsonee()
        .fetch(),
    getById: (id) =>
      new Requeste(`/order/${id}`, {
        method: "GET",
      })
        .authee()
        .jsonee()
        .fetch(),
    accept: (id, deliveryFee) =>
      new Requeste(`/order/${id}/accept`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ deliveryFee }),
      })
        .authee()
        .jsonee()
        .fetch(),
    prepare: (id) =>
      new Requeste(`/order/${id}/prepare`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .authee()
        .jsonee()
        .fetch(),
    ready: (id) =>
      new Requeste(`/order/${id}/ready`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .authee()
        .jsonee()
        .fetch(),
    complete: (id) =>
      new Requeste(`/order/${id}/complete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .authee()
        .jsonee()
        .fetch(),
    reject: (id, reason) =>
      new Requeste(`/order/${id}/reject`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ reason }),
      })
        .authee()
        .jsonee()
        .fetch(),
  },
  users: {
    getCurrent: () =>
      new Requeste("/user", { method: "GET" }).authee().jsonee().fetch(),
  },
  payments: {
    getTransactions: (startingAfter, kitchenId) => {
      const qs = [
        startingAfter ? `startingAfter=${startingAfter}` : null,
        kitchenId ? `kitchenId=${kitchenId}` : null
      ].filter(q => q)
      return new Requeste(
        `/payment/transactions${qs.length ? `?${qs.join("&")}` : ""
        }`,
        {
          method: "GET",
        }
      )
        .authee()
        .jsonee()
        .fetch()
    },
    getPayouts: (startingAfter, kitchenId) => {
      const qs = [
        startingAfter ? `startingAfter=${startingAfter}` : null,
        kitchenId ? `kitchenId=${kitchenId}` : null
      ].filter(q => q)
      return new Requeste(
        `/payment/payouts${qs.length ? `?${qs.join("&")}` : ""
        }`,
        {
          method: "GET",
        }
      )
        .authee()
        .jsonee()
        .fetch()
    },
    getStats: (kitchenId) =>
      new Requeste(`/payment/stats${kitchenId ? `?kitchenId=${kitchenId}` : ""}`, {
        method: "GET",
      })
        .authee()
        .jsonee()
        .fetch(),
  },
};
